<template>
  <div class="list" name="info">
    <el-col style="margin-top:-18px">
      <el-form :inline="true" class="demo-inline-form" :model="search_qrcode">
        <el-card class="searchCard" shadow="never">
          <el-form-item label="绑定时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              @change="dateChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input
              style="width:160px;"
              v-model="search_qrcode.fMerchantId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input
              style="width:160px;"
              v-model="search_qrcode.FMerchantName"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="绑定方式">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FBindType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="手动绑定" value="1"></el-option>
              <el-option label="自动绑定" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="qrcodeType in qrcodeTypeList" :key="qrcodeType.code" :label="qrcodeType.name" :value="qrcodeType.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="码牌号">
            <el-input
              style="width:250px;"
              v-model="search_qrcode.FQrcodeNum"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FState"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="开通" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="绑定操作人">
            <el-input
              style="width:150px;"
              v-model="search_qrcode.FOperator"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="批次号">
            <el-input
              style="width:250px;"
              v-model="search_qrcode.FBatchNo"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="消费者备注必填">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FRemarkFlag"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="开通" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机具号">
            <el-input
              style="width:250px;"
              v-model="search_qrcode.FFactoryNum"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="qrcodeLoading"
              label="查询"></auth-button>
            <auth-button
              opt="batch_unbind"
              @click.native="showUnbindForm"
              label="批量解绑"></auth-button>
          </el-form-item>
        </el-card>
        <el-card class="tableCard" shadow="never">
          <!-- 列表模块 -->
          <el-table
            stripe
            style="width:100%"
            align="center"
            v-loading="qrcodeLoading"
            :data="qrcode_list"
            :header-cell-style="{background:'#FAFAFA'}"
            @sort-change="tableSortChange"
          >
            <el-table-column
              prop="fBindTime"
              label="绑定时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="fQrcodeNum"
              label="码牌号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fQrcodeType"
              label="类型"
              :formatter="formatType"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fBindType"
              label="绑定方式"
              :formatter="formatBindType"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fBatchNo"
              label="批次号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fMerchantId"
              label="商户编号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fMerchantName"
              label="商户简称"
              align="center">
            </el-table-column>
            <el-table-column
              prop="realState"
              label="交易状态"
              :formatter="formatState"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fRemarkFlag"
              label="消费者备注必填"
              :formatter="formatRemarkFlag"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fOperator"
              label="绑定操作人"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fFactoryNum"
              label="机具号"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              width="420"
              align="left"
              fixed="right"
              :context="_self">
              <template slot-scope="scope">
                <auth-button
                  opt="details"
                  type="text"
                  label="查看"
                  @click.native="handleCheck(scope.$index, scope.row)"></auth-button>
                <auth-button
                  opt="disabled"
                  type="text"
                  v-if="scope.row.realState !== 0 && scope.row.closeByOperate === 0 && scope.row.fState !== 0 && (scope.row.fQrcodeType==null||scope.row.fQrcodeType!=2)"
                  prop="fBlockStatus"
                  label="禁用"
                  @click.native="handleState(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="enable"
                  type="text"
                  v-if="scope.row.realState !== 0 && scope.row.closeByOperate === 0 && scope.row.fState === 0 && (scope.row.fQrcodeType==null||scope.row.fQrcodeType!=2)"
                  prop="fBlockStatus"
                  label="启用"
                  @click.native="handleState(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="close_remark"
                  type="text"
                  v-if="scope.row.fRemarkFlag === 1 && (scope.row.fQrcodeType==null||scope.row.fQrcodeType!=2)"
                  v-show="scope.row.fRemarkFlag === 1 && (scope.row.fQrcodeType==null||scope.row.fQrcodeType!=2)"
                  prop="fBlockStatus"
                  label="备注关闭"
                  @click.native="handleRemark(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="open_remark"
                  type="text"
                  v-if="scope.row.fRemarkFlag === 0 && (scope.row.fQrcodeType==null||scope.row.fQrcodeType!=2)"
                  prop="fBlockStatus"
                  label="备注开通"
                  @click.native="handleRemark(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="set_audio"
                  class="marginTop"
                  type="text"
                  v-if="scope.row.fQrcodeType === 4 || scope.row.fQrcodeType === 10"
                  prop="fBlockStatus"
                  label="语音播报设置"
                  @click.native="setAudio(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="unbind"
                  class="marginTop"
                  type="text"
                  v-if="scope.row.fQrcodeType === 4 || scope.row.fQrcodeType === 10"
                  prop="fBlockStatus"
                  label="解绑"
                  @click.native="editBindQr(scope.row,2)"></auth-button>
                <auth-button
                  opt="bind"
                  class="marginTop"
                  type="text"
                  v-if="scope.row.fQrcodeType === 10 && scope.row.fFactoryNum === ''"
                  prop="fBlockStatus"
                  label="绑定SN"
                  @click.native="toBindQr(scope.row)"></auth-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </el-col>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!-- 查看界面 -->
    <el-dialog title="" :visible.sync="dialogVisible" size="small" width="35%">
      <div class="codeImgBox">
        <img src="../../../../static/images/unionCode.png" class="top_img codeImg" id="codeImg1" v-if="checkBasic.show">
        <img src="../../../../static/images/unionCode2.png" class="top_img codeImg" id="codeImg2" v-if="!checkBasic.show">
        <img src="../../../../static/images/unionPayDownload.png" class="top_img codeImgDownload hide" v-if="checkBasic.show">
        <img src="../../../../static/images/unionPayDownload2.png" class="top_img codeImgDownload hide" v-if="!checkBasic.show">
        <div class="qr-code-tip-view">
          <div>商户简称:{{ checkBasic.merchantName || '未设置' }}</div>
        </div>
        <div id="img_box"></div>
        <!--          <div class="tip-wx-check">添加乐刷公众号(leshua2011)验真伪</div>-->
        <p id="leposNum">NO:<span>{{ checkBasic.qrcodeNum }}</span></p>
        <div id="ewm_img" class="hide">
          <img class="top_img" src="" id="top_img">
        </div>
        <a id="hello"></a>
        <div class="canvas-container hide" style="width: 375px; height: 585px; position: relative; user-select: none;">
          <canvas id="main" width="750" height="1170" class="hide lower-canvas" style="position: absolute; width: 375px; height: 585px; left: 0px; top: 0px; touch-action: none; user-select: none;"></canvas>
          <canvas class="upper-canvas hide" width="375" height="585" style="position: absolute; width: 375px; height: 585px; left: 0px; top: 0px; touch-action: none; user-select: none;"></canvas>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="saveQrcode()" :loading="checkBasic.checkLoading">保存二维码</el-button>
        <el-button @click="dialogVisible = false" >关  闭</el-button>
      </span>
    </el-dialog>

    <!-- 语音播报编辑界面 -->
    <el-dialog title="语音播报编辑" :visible.sync="dialogEditVisible" size="small" @close="closeViewDialog">
      <el-form v-show="dialogInfoVisible">
        <el-row >
          <el-form
            label-width="200px"
            ref="basic"
            :model="basic">
            <el-form-item label="商户交易是否全部推送" prop="fPushAll">
              <el-radio-group v-model="basic.fPushAll">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="收银通app交易推送" prop="fPushApp" v-if="basic.fPushAll==1">
              <el-radio-group v-model="basic.fPushApp">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="收银通pc版交易推送" prop="fPushPc" v-if="basic.fPushAll==1">
              <el-radio-group v-model="basic.fPushPc">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="收款二维码交易推送" prop="fPushQrcode" v-if="basic.fPushAll==1" v-loading="pushQrcodeLoading">
              <el-checkbox :indeterminate="isIndeterminate" v-model="componentCheckAll" @change="handleComponentCheckAllChange">全选</el-checkbox>
              <el-checkbox-group v-model="basic.fPushQrcode" @change="handleComponentCheckedChange">
                <el-checkbox :label="one" v-for="(one, index) of nums_list" :key="index"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer" style="width:100%" v-show="true">
        <el-button @click="dialogEditVisible = false" >取 消</el-button>
        <el-button icon="el-icon-edit" type="primary" @click="editSubmit" :loading="addLoading" :disabled="pushDialogDisabled">修改</el-button>
      </span>
    </el-dialog>

    <el-dialog title="绑定机具" :visible.sync="bindDialogVisible" width="500px">
      <el-form>
        <el-form-item label="机具号：" required>
          <el-input v-model="FFactoryNum" placeholder="请输入16位以“X100BASH”开头机具号" :maxLength="16"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="bindDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="editBindQr(editRow,1)">确定</el-button>
      </div>
    </el-dialog>

    <!-- 批量解绑 -->
    <el-dialog
      v-if="unbindDialogVisible"
      :visible.sync="unbindDialogVisible"
      title="批量解绑"
      width="500px"
      :close-on-click-modal="false">
      <ul class="tips">
        <li>请下载批量解绑模板文件，并将码牌信息按格式要求填入文件中</li>
        <li>如解绑码牌数量较多，建议分批导入，每次导入不超过300个码牌</li>
      </ul>
      <a :href="templateUrl" download><el-button size="small" type="primary">下载模板文件</el-button></a>
      <input type="file" id="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
      <el-button type="primary" plain size="small" class="check" @click="getMultiFiles()">批量导入</el-button>
      <p class="info">仅支持.xls/.xlsx格式</p>
      <el-col v-if="multiFileName !== ''" class="hasSelect">
        <span>已选择: {{ multiFileName }}</span>
        <i class="el-icon-remove removeIcon" @click="removeFile"></i>
      </el-col>
      <div slot="footer">
        <el-button size="small" @click="unbindDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="batchUnbind" :loading="buttonLoading">确认</el-button>
      </div>
    </el-dialog>

    <!-- 批量解绑结果 -->
    <el-dialog title="批量解绑完成" :visible.sync="importDialogVisible" center width="500px" :append-to-body="true">
      <p class="resultInfo">成功{{ this.successNum }}条，失败{{ this.failNum }}条</p>
      <el-table border size="small" :data="failData">
        <el-table-column prop="type" label="码牌类型" width="70" align="center"></el-table-column>
        <el-table-column prop="qrcode" label="码牌编号" width="120" align="center"></el-table-column>
        <el-table-column prop="branch" label="设备厂商" width="80" align="center"></el-table-column>
        <el-table-column prop="failMsg" label="失败原因" align="center"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量解绑完成" :visible.sync="importInfoDialogVisible" center width="500px" :append-to-body="true">
      <p class="resultInfo">成功{{ this.successNum }}条，失败{{ this.failNum }}条<br/>失败数量较多，请前往下载中心查看失败原因</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importInfoDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="jumpLink">去下载中心</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import qs from 'qs'
// export default {RecordJs};
import { getBindlistQrcode, setQrcodeAudio, getQrcodePage, changeQrcodeState, listMerchantQrcode, getQrcodeType, batchUnbind } from '@/api/machine'
import { fabric } from 'fabric'
export default {
  data () {
    return {
      comeTime: '',
      qrcode_list: [],
      branch_list: [],
      effect_privilege_level_list: [],
      areas: [],
      citys: [],
      data: [],
      pos: [],
      scan: [],
      dataParam: {},
      domain: 'https://pos.yeahka.com/',
      picDomain: 'https://pic.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      qrcodeNum: '',
      staffsNum: '',
      roleName: '',
      qrcodeLoading: false,
      dialogVisible: false,
      addLoading: false,
      checkLoading: false,
      authLoading: false,
      picLoading: false,
      zfztDisabledInput: true,
      gzztDisabledInput: true,
      groupIdDisabledInput: false,
      disabledInput: false,
      editLoading: false,
      holderDisabledInput: false,
      headShopMerchantIdInput: false,
      publicsignalAppidGZItem: true,
      publicsignalAppidItem: true,
      publicsignalAuthorizationDirectoryItem: true,
      pushDialogDisabled: false,
      settleDialogDisabled: false,
      settleToDisabled: false,
      nopassReason: false,
      editable: false,
      dialogEditVisible: false,
      dialogInfoVisible: false,
      componentCheckAll: false,
      isIndeterminate: false,
      nums_list: [],
      pushQrcodeLoading: false,

      picLoadingArr: [{ idcardFront: false }, { idcardBack: false },
        { bankcardFront: false },
        { businessLicenseC: false },
        { doorPhoto: false },
        { cashierDesk: false },
        { businessInside: false },
        { nonLegSettleAuth: false },
        { nonLegIdcardFront: false },
        { nonLegIdcardBack: false },
        { protocolPage: false },
        { taxRegCert: false },
        { organizationCode: false },
        { leaseContract: false }],
      userId: '',
      userName: '',
      // 搜索表单信息
      search_qrcode: {
        startTime: '',
        endTime: '',
        FMerchantId: '',
        FMerchantName: '',
        FBindType: '',
        FQrcodeNum: '',
        FState: '',
        FOperator: '',
        FBatchNo: '',
        FRemarkFlag: '',
        FType: '',
        FFactoryNum: ''

      },
      basic: {
        fAddress: '',
        fArea: '',
        fBankAccount: '',
        fBankAccountType: '',
        fUserPassword: '',
        fBankCity: '',
        fBankArea: '',
        fServicePhone: '',
        fCredentialType: 1,
        fBankBranch: '',
        fBankName: '',
        fBankcardPhone: '',
        fIdcard: '',
        fMerchantId: '',
        fMerchantName: '',
        publicsignalAppidGZ: '',
        gzhMerchantName: '',
        publicsignalAppid: '',
        publicsignalAuthorizationDirectory: '',
        shopTye: '',
        settleTo: '',
        headShopMerchantId: '',
        fPushAll: '',
        fPushApp: '',
        fPushPc: '',
        fPushQrcode: [],
        fId: ''
      },
      audioEdit: {
        fMerchantId: '',
        fPushAll: '',
        fPushApp: '',
        fPushPc: '',
        fPushQrcode: '',
        fId: ''
      },
      checkBasic: {
        qrcodeNum: '',
        qrUrL: '',
        qrcode: null,
        checkLoading: false,
        imgsrc: '',
        show: true
      },
      pics: {
        idcardFront: '',
        idcardBack: '',
        bankcardFront: '',
        businessLicenseC: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        protocolPage: '',
        nonLegSettleAuth: '',
        nonLegIdcardFront: '',
        nonLegIdcardBack: '',
        taxRegCert: '',
        organizationCode: '',
        leaseContract: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面
        idcardFrontUrl: '',
        idcardBackUrl: '',
        bankcardFrontUrl: '',
        businessLicenseCUrl: '',
        doorPhotoUrl: '',
        cashierDeskUrl: '',
        businessInsideUrl: '',
        protocolPageUrl: '',
        nonLegSettleAuthUrl: '',
        taxRegCertUrl: '',
        organizationCodeUrl: '',
        leaseContractUrl: ''
      },

      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      qrcodeTypeList: [],
      FFactoryNum: '', // 机具号
      bindDialogVisible: false, // 绑定SN号的弹窗显示
      editRow: {}, // 当前操作的行
      unbindDialogVisible: false,
      templateUrl: 'static/批量解绑模板.xlsx',
      multiFile: '',
      multiFileName: '',
      importDialogVisible: false,
      failNum: 0,
      successNum: 0,
      failData: [],
      importInfoDialogVisible: false,
      buttonLoading: false
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getQrcodeTypeFn()
    this.getList()
  },
  methods: {
    /**
       * 返回配件全选点击
       */
    handleComponentCheckAllChange (value) {
      this.basic.fPushQrcode = value ? this.componentCheckOptions : []
      this.isIndeterminate = false
    },
    /**
       * 返回配件选择点击
       */
    handleComponentCheckedChange (value) {
      const checkedCount = value.length
      this.componentCheckAll = checkedCount === this.componentCheckOptions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.componentCheckOptions.length
    },
    closeViewDialog () {
    },
    // 语音播报设置
    setAudio (row, index, scope) {
      this.basic.fPushAll = ''
      this.basic.fPushApp = ''
      this.basic.fPushPc = ''
      this.basic.fPushQrcode = []

      this.audioEdit.fQrcodeNum = row.fQrcodeNum
      this.dialogEditVisible = true
      this.dialogInfoVisible = true
      this.pushQrcodeLoading = true
      this.pushDialogDisabled = true

      this.basic.fPushAll = '' + row.fPushAll
      this.basic.fPushApp = '' + row.fPushApp
      this.basic.fPushPc = '' + row.fPushPc
      if (row.fPushQrcode !== null) {
        this.basic.fPushQrcode = row.fPushQrcode.split(',')
      }
      var data = {
        FMerchantId: row.fMerchantId
      }
      data = qs.stringify(data)
      getBindlistQrcode(data).then((data) => {
        if (parseInt(data.error_code) === 0) {
          console.log(data.data)
          this.nums_list = data.data
          this.componentCheckOptions = data.data
          this.pushQrcodeLoading = false
          this.pushDialogDisabled = false
        } else {
          this.$message({
            message: data.error_msg,
            type: 'error'
          })
        }
      })
    },
    // 语音播报编辑
    editSubmit () {
      this.audioEdit.fMerchantId = this.basic.fMerchantId
      this.audioEdit.fPushAll = this.basic.fPushAll
      this.audioEdit.fPushApp = this.basic.fPushApp
      this.audioEdit.fPushPc = this.basic.fPushPc
      var that = this
      var FPushQrcode = this.basic.fPushQrcode
      this.audioEdit.fPushQrcode = FPushQrcode.join(',')

      that.$confirm('确认提交吗？', '提示', {}).then(() => {
        that.addLoading = true
        that.editLoading = true
        let para = Object.assign({}, that.audioEdit)
        para = qs.stringify(para)
        setQrcodeAudio(para).then(data => {
          that.addLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            that.getList()
            that.editLoading = false
            this.dialogEditVisible = false
            this.dialogInfoVisible = false
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.editLoading = false
          }
        })
      })
    },
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_qrcode.FStartTime = value[0]
        this.search_qrcode.FEndTime = value[1]
      } else {
        this.search_qrcode.FStartTime = ''
        this.search_qrcode.FEndTime = ''
      }
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    // 显示查看界面
    handleCheck (index, row, scope) {
      if (this.checkBasic.qrcode !== null) {
        document.getElementById('img_box').innerHTML = ''
      }
      this.dialogVisible = true
      if (row.fQrcodeType !== null && row.fQrcodeType === 2) { // 银联固码
        this.checkBasic.show = true
      } else { // 其他
        this.checkBasic.show = false
      }
      this.checkBasic.checkLoading = true
      this.checkBasic.qrcode = null
      this.checkBasic.qrcodeNum = row.fQrcodeNum
      this.checkBasic.qrUrl = ''
      this.checkBasic.merchantName = row.fMerchantName
      var merchantId = row.fMerchantId === '' ? '11111111' : row.fMerchantId// 商户编号,若为空,默认为"11111111"
      var qrcodeNum = row.fQrcodeNum// 码牌号
      var data = {
        FMerchantId: merchantId,
        FQrcodeNum: qrcodeNum
      }
      data = qs.stringify(data)
      getQrcodePage(data).then(response => {
        if (parseInt(response.error_code) === 0) {
          var qrUrl = response.qrUrl
          // if (row.fQrcodeType==null || (row.fQrcodeType!=2 && row.fQrcodeType!=5)) {//非银联固码
          //   qrUrl = qrUrl+"&source_type=33";
          // }
          this.qrCodeSave(qrUrl, qrcodeNum, row.fMerchantName)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    qrCodeSave (qrUrl, qrcodeNum, merchantName) {
      var url = qrUrl
      const that = this
      document.getElementById('img_box').innerHTML = ''
      this.checkBasic.qrcode = new QRCode(document.getElementById('img_box'), {
        width: 200, // 设置宽高
        height: 200
      })
      this.checkBasic.qrcode.clear()
      this.checkBasic.qrcode.makeCode(url)
      // eslint-disable-next-line no-undef
      fabric.Object.prototype.transparentCorners = false
      // eslint-disable-next-line no-undef
      var canvas1 = window._canvas = new fabric.Canvas('main')
      this.$jquery('.canvas-container').addClass('hide')
      this.$jquery('#img_box img')[0].onload = function () {
        // var domain='https://pos.yeahka.com/';
        // domain+'../../../../static/images/unionPayCode.png'
        // wxs.yeahka.com:443/o2o/resources/images/unionPayCode.png
        var src = that.$jquery('.codeImgDownload').attr('src')
        // eslint-disable-next-line no-undef
        fabric.Image.fromURL(src, function (image) {
          image.set({
            width: 390,
            height: 500,
            top: -250,
            left: -250,
            margin: '0 auto'
          })
          var img1 = image.scale(1).setCoords()
          const merchantNameStr = `商户简称:${merchantName || '未设置'}`
          // eslint-disable-next-line no-undef
          const merchantNameText = new fabric.Text(merchantNameStr, {
            fontSize: 14,
            fill: '#333',
            top: -168,
            left: -merchantNameStr.length * 14 / 2 - 50
          })
          // const checkQRTipText = new fabric.Text('添加乐刷公众号(leshua2011)验真伪', {
          // eslint-disable-next-line no-undef
          const checkQRTipText = new fabric.Text('', {
            fontSize: 13,
            fill: '#27499d',
            textAlgin: 'center',
            left: -152,
            top: 150,
            margin: '0 auto'
          })
          // eslint-disable-next-line no-undef
          var text = new fabric.Text('NO：' + qrcodeNum, {
            fontSize: 10,
            fill: '#ffffff',
            textAlgin: 'center',
            left: -125,
            top: 230
          })
          // eslint-disable-next-line no-undef
          fabric.Image.fromURL(that.$jquery('#img_box img').attr('src'), function (image) {
            image.set({
              width: 200,
              height: 200,
              left: -152,
              top: -138
            })
            // new fabric.Image.filters.RemoveWhite({threshold: 60, distance: 60})
            var img2 = image.scale(1).setCoords()
            // eslint-disable-next-line no-undef
            var group = new fabric.Group([img1, merchantNameText, checkQRTipText, img2, text],
              {
                width: 766,
                height: 902
              },
              {
                width: 300,
                height: 300
              },
              {
                width: 300,
                height: 300
              }
            )
            // var text = image.scale(1).setCoords();
            canvas1.add(group)
            canvas1.renderAll()
            canvas1.calcOffset()
            canvas1.setActiveObject(group)
            that.$jquery('#ewm_img img').attr('src', canvas1.toDataURL({
              format: 'png',
              quality: 0.4,
              width: 663,
              height: 910
            }))
          })
        })
      }
      this.checkBasic.checkLoading = false
    },
    // 保存二维码
    saveQrcode () {
      this.checkBasic.checkLoading = true
      var url = this.$jquery('#ewm_img #top_img').attr('src')
      var triggerDownload = this.$jquery('#hello').attr('href', url).attr('download', '乐刷扫码二维码.png')
      triggerDownload[0].click()
      this.checkBasic.checkLoading = false
    },
    // 更改状态
    handleState (row, index, scope) {
      var qrcodeNum = row.fQrcodeNum
      var state = row.fState
      // OperationType 0.交易开通/关闭 1.备注开通关闭 2.绑定、解绑
      var operationType = 0
      var data = {
        FQrcodeNum: qrcodeNum,
        FState: (state === 1 ? 0 : 1),
        OperationType: operationType
      }
      data = qs.stringify(data)
      this.$confirm(
        state === 0
          ? '是否启用码牌' + row.fQrcodeNum + '，启用后，商户可使用使用该码牌收银？'
          : '是否禁用码牌' + row.fQrcodeNum + '，禁用后，商户将无法使用该码牌收银？',
        state === 0 ? '启用' : '禁用' + '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        changeQrcodeState(data).then((data) => {
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
          this.getList()
        })
      })
    },
    // 更改备注
    handleRemark (row, index, scope) {
      var qrcodeNum = row.fQrcodeNum
      var remarkFlag = row.fRemarkFlag
      // OperationType 0.交易开通/关闭 1.备注开通关闭 2.绑定、解绑
      var operationType = 1
      var data = {
        FQrcodeNum: qrcodeNum,
        FRemarkFlag: (remarkFlag === 1 ? 0 : 1),
        OperationType: operationType
      }
      data = qs.stringify(data)
      this.$confirm(
        '备注' + (remarkFlag === 0 ? '开通' : '关闭') + '后，消费者扫码付款时，' + (remarkFlag === 0 ? '必须' : '不用') +
            '填写备注，' + (remarkFlag === 0 ? '才' : '就') + '能支付，请确认是否' + (remarkFlag === 0 ? '开通' : '关闭') + '。',
        '备注' + (remarkFlag === 0 ? '开通' : '关闭') + '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        changeQrcodeState(data).then((data) => {
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
          this.getList()
        })
      })
    },
    // 解绑,类型1绑定，2解绑
    editBindQr (row, type) {
      var qrcodeNum = row.fQrcodeNum
      // OperationType 0.交易开通/关闭 1.备注开通关闭 2.绑定、解绑
      var operationType = 2
      // fbs 绑定/解绑标志 1、绑定 2.解绑
      var fbs = type
      var data = {
        FQrcodeNum: qrcodeNum,
        OperationType: operationType,
        FBindState: fbs,
        FMerchantId: row.fMerchantId
      }
      let askLabel = ''
      if (fbs === 1) {
        askLabel = '确认绑定码牌'
        if (/^X100BASH\S{8}/.test(this.FFactoryNum)) {
          data.FFactoryNum = this.FFactoryNum
        } else {
          this.$message({
            message: '请输入正确的机具号',
            type: 'warning'
          })
          return
        }
      } else {
        data.FFactoryNum = row.fFactoryNum
        askLabel = '确认解绑码牌'
      }
      data = qs.stringify(data)
      this.$confirm(
        askLabel + qrcodeNum + '?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        changeQrcodeState(data).then((data) => {
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList()
            this.bindDialogVisible = false
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {

      })
    },
    tableSortChange (val) {
      this.getList()
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.qrcodeNum
      // var pageSize = this.qrcode_list.length;
      this.search_qrcode.pageNo = page
      // this.search_qrcode.pageSize = pageSize;
      this.search_qrcode.Count = totalCount
      // this.search_qrcode.pageSize = size;
      this.getList()
    },
    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      var totalCount = this.qrcodeNum
      var pageNo = this.paginations.pageNum
      this.search_qrcode.pageSize = size
      this.search_qrcode.pageNo = pageNo
      this.search_qrcode.Count = totalCount
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.checkLoading = true
      // this.search_qrcode.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_qrcode.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    getList () {
      this.qrcodeLoading = true
      var data = this.formatSearch(this.search_qrcode)
      data = qs.stringify(data)
      listMerchantQrcode(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.qrcodeLoading = false
        } else {
          this.qrcodeLoading = false
          this.paginations.total = data.data.totalCount
          this.qrcode_list = data.data.list
          this.qrcodeNum = data.data.totalCount
        }
      })
    },
    formatBindType (item) {
      return item.fBindType === 0 ? '未绑定' : (item.fBindType === 1 ? '手动绑定' : '自动绑定')
    },
    formatState (item) {
      var str = ''
      if (item.realState === 0) {
        str = '关闭'
      } else {
        str = item.fState === 0 ? '关闭' : '开通'
      }
      return str
    },
    formatRemarkFlag (item) {
      return item.fRemarkFlag === 0 ? '关闭' : '开通'
    },
    formatType (item) {
      if (item.fQrcodeType === 2) return '乐刷收款二维码'
      const typeList = this.qrcodeTypeList.filter(function (type) {
        return type.code === item.fQrcodeType
      })
      if (typeList.length > 0) {
        return typeList[0].name
      } else {
        return '未知'
      }
    },
    /**
       * 获取码牌类型
       */
    getQrcodeTypeFn () {
      getQrcodeType('').then(response => {
        console.log('getQrcodeType response:', response)
        this.qrcodeTypeList = response.list || []
      })
    },
    // 绑定机具
    toBindQr (row) {
      this.editRow = row
      this.FFactoryNum = ''
      this.bindDialogVisible = true
    },
    /**
       * @description 选择文件
       */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    /**
       * @description 删除已上传文件
       */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    getMultiFiles () {
      this.$jquery('#file').click()
    },
    jumpLink () {
      this.$router.push('/index/DownloadCenter')
    },
    /**
     * @description 批量解绑
     */
    batchUnbind () {
      if (this.multiFile === '') {
        this.$message({
          message: '请先上传文件',
          type: 'warning'
        })
        return
      }
      this.buttonLoading = true
      const data = new FormData()
      data.append('unBindFile', this.multiFile)
      batchUnbind(data).then((data) => {
        this.buttonLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          console.log(data.data)
          this.successNum = data.data.sucessNum
          if (data.data.failNum === 0) {
            this.$message({
              showClose: true,
              message: data.error_msg + '，成功解绑' + data.data.sucessNum + '条',
              type: 'success'
            })
          } else if (data.data.failNum <= 20) {
            console.log(this.failData)
            this.importDialogVisible = true
            this.failNum = data.data.failNum
            this.failData = data.data.failList
          } else {
            this.importInfoDialogVisible = true
            this.failNum = data.data.failNum
          }
          this.unbindDialogVisible = false
          this.getList()
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '请求超时，请稍后重试',
          type: 'error'
        })
      })
    },
    showUnbindForm () {
      this.multiFile = ''
      this.multiFileName = ''
      this.unbindDialogVisible = true
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .demo-inline-form {
    margin-top: 18px;
  }

  .btm-action {
    margin: 20px 0;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  /deep/ .el-form-item__label{
    text-align: left;
  }
  .codeImgBox {
    width: 390px;
    height: 500px;
    border-radius: 20px;
    // margin: 46px 0 30px 46px;
    margin: 0 auto;
    position: relative;
  }
  .codeImgBox .top_img {
    width: 100%;
  }
  .codeImgBox #img_box {
    width: 200px;
    height: 200px;
    position: relative;
    bottom: 79%;
    left: 24%;
  }
  .codeImgBox #img_box img {
    width: 100%;
    height: 100%;
  }
  .codeImgBox #leposNum {
    position: absolute;
    font-size: 10px;
    color: #fff;
    width: 100%;
    text-align: center;
    /* display: none; */
    top: 93%;
    left: 0%;
  }
  .codeImgBox .qr-code-tip-view {
    position: absolute;
    width: 100%;
    top: 16%;
    font-size: 14px;
    text-align: center;
  }
  .codeImgBox .qr-code-tip-view > div {
    height: 20px;
    line-height: 20px;
  }
  .tip-wx-check {
    position: absolute;
    width: 100%;
    bottom: 17%;
    font-size: 13px;
    text-align: center;
    color: #27499d;
    height: 20px;
    line-height: 20px;
  }
  .hide {
    display: none;
  }
  .marginTop{
    margin-top: 10px;
  }
  .hasSelect{
        font-size: 15px;
        margin-top: 20px;
    }
  .hasSelect span{
      float: left;
      margin-bottom: 20px;
      line-height: 30px;
      display: inline-block;
      max-width: 430px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .hasSelect .removeIcon{
      color:#F56C6C;
      line-height: 30px;
      cursor: pointer;
      margin-left: 10px;
  }
  .tips{
    margin: 0;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 20px;
    list-style: disc;
    & li {
      margin-left: 36px;
    }
  }
  .check {
      margin-left:5px
  }
  .info {
    margin-top: 16px;
  }
  .resultInfo {
    line-height: 24px;
  }
</style>
